import styled from 'styled-components';
import { font } from '@design/templateFns';
import { space, query } from '@design/templateFns';

export const TopDefault = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${space('x6')} ${space('xl')};
  box-sizing: border-box;

  @media screen and (${query.atLeast('tablet')}) {
    padding: ${space('x6')} ${space('x8')};
  }
`;

export const BigHeader = styled.h4`
  ${font('headline-xxs')}
  padding: 0;
  margin: 0;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('headline-xs')}
  }
`;
